<template>
	<div class="ui-mif" @focusout="onFocusOut" tabindex="0">
		<div class="ui-mif__elm" @click="onFocus">
			<div class="ui-mif__elm-search">
				<input
					ref="searchInput"
					@input="search"
					type="text"
					class="ui-mif__elm-search-input"
					:placeholder="label"
					:value="selectedId"
				/>

				<IconSearch
					v-if="isShowIcon"
					class="ui-mif__elm-search-icon"
					color="rgb(119, 121, 124)"
					width="16"
					height="16"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconSearch from "@/components/icons/IconSearch.vue";

@Options({
	components: { IconSearch },
	props: {
		label: { type: String, default: "" },
		isShowIcon: { type: Boolean, default: true },
		selectedId: { type: String, default: "" },
	},
})
export default class UiMobileInputFilter extends Vue {
	public text = "";

	/**
	 * Устанавливаем курсор в область поля ввода
	 */
	public onFocus() {
		const searchInput = this.$refs.searchInput as HTMLInputElement;
		searchInput.focus();
		this.$emit("is-focus", true);
	}

	/**
	 * Потеря фокуса, если кликнули за его пределами
	 */
	public onFocusOut() {
		this.$emit("is-focus", false);
	}

	/**
	 * Обрабртка события input
	 * @param event
	 */
	public search(event: Event) {
		this.text = (event.target as HTMLInputElement).value;
		this.$emit("filter", this.text);
	}
}
</script>

<style scoped lang="scss">
.ui-mif {
	&__elm {
		cursor: pointer;
	}

	&__elm-search {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		direction: ltr;
		border: 1px solid rgb(244, 246, 250);
		border-radius: 12px;
		padding: 12px;
		background-color: rgb(244, 246, 250);
		min-width: 10px;
	}

	&__elm-search-input {
		background-color: rgb(244, 246, 250);
		border: 1px solid rgb(244, 246, 250);
		font-size: 16px;
		color: rgb(119, 121, 124);
		width: 90%;
	}

	&__elm-search-input:focus {
		outline-color: rgb(244, 246, 250);
		outline-style: solid;
		color: rgb(119, 121, 124);
	}

	&__elm-search-icon {
		display: flex;
		width: 25px;
		justify-content: flex-end;
	}
}
</style>
